"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaxonomyEntityExpertise = exports.TaxonomyEntityExpertiseDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var grid_1 = require("../elements/grid");
var lodash_1 = require("lodash");
var entity_link_value_1 = require("./entity-link-value");
var content_section_1 = require("../elements/content-section");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var entity_reverse_controls_1 = require("../../v2/entities/entity-reverse-controls");
exports.TaxonomyEntityExpertiseDefaultProps = {
  title: 'Community Expertise & Interest:'
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n    ", ";\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n    ", ";\n    &:last-child {\n      background: none;\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1), theme_1.theme.H_DOT_BG_END('line-subtle'))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-right: ", ";\n  "], ["\n    margin-bottom: ", ";\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(10))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  "])))
});
var ReverseControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Items: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Value: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  ReverseControls: (0, styled_components_1.default)(entity_reverse_controls_1.EntityReverseControls)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ReverseControlsStyles)
};
var TaxonomyEntityExpertise = function (props) {
  var _a;
  var className = props.className,
    entity = props.entity,
    title = props.title;
  var _b = entity.expertise,
    expertise = _b === void 0 ? [] : _b;
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var t = (0, use_lang_1.useLang)();
  var hasExpertise = !!expertise.length;
  var sortExpertise = ((_a = defn.taxonomy) === null || _a === void 0 ? void 0 : _a.sortExpertise) || function (items) {
    if (items === void 0) {
      items = [];
    }
    return (0, lodash_1.sortBy)(items, function (item) {
      var _a, _b;
      return "".concat((0, lodash_1.padStart)((0, lodash_1.toString)((_a = item.levelOfExpertise) === null || _a === void 0 ? void 0 : _a.orderNumber), 10, '0')).concat((_b = item.person) === null || _b === void 0 ? void 0 : _b.name);
    });
  };
  return react_1.default.createElement(My.Container, {
    className: className,
    title: title,
    titleSuffix: hasExpertise ? '' : ' (none recorded)',
    controls: react_1.default.createElement(My.ReverseControls, {
      entity: entity,
      reverseEntityTypeNames: ["SdgExpertise", "TopicExpertise", "TrendExpertise", "SubTopicExpertise", "KeyIssueExpertise", "ChallengeExpertise"]
    })
  }, react_1.default.createElement(My.Items, null, (0, lodash_1.map)((0, lodash_1.groupBy)((0, lodash_1.filter)(sortExpertise(expertise)), function (ex) {
    var _a;
    return (_a = ex.levelOfExpertise) === null || _a === void 0 ? void 0 : _a.name;
  }), function (items, level) {
    return react_1.default.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: (0, lodash_1.map)(items, function (ex) {
        var label = ex && ex.levelOfExpertise && ex.levelOfExpertise.name;
        var person = ex.person;
        if (person) {
          return react_1.default.createElement(My.Value, {
            showMenu: true,
            badge: ex.badge,
            menuEntity: ex,
            entity: person,
            label: label
          });
        }
      })
    });
  })));
};
exports.TaxonomyEntityExpertise = TaxonomyEntityExpertise;
exports.TaxonomyEntityExpertise.defaultProps = exports.TaxonomyEntityExpertiseDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;